import * as React from 'react';
import * as PropTypes from 'prop-types';

import Modal from '../../../components/Modal';
import Button from '../../../components/Button';

import { PopupLoading } from './PopupLoading';

export class RemoveCheckPopup extends React.Component {
  static propTypes = {
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    inProcess: PropTypes.bool,
  };

  handleOkClick = (e) => {
    e.preventDefault();

    const { onOk } = this.props;

    if (typeof onOk === 'function') {
      onOk();
    }
  };

  handleCancelClick = (e) => {
    e.preventDefault();

    const { onCancel } = this.props;

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  render() {
    return (
      <Modal showModal={true} hasCloseIcon={false}>
        {this.props.inProcess && <PopupLoading />}
        <a className="mfp-close popup_close" onClick={this.handleCancelClick} />

        <h2>{'Удалить чек?'}</h2>

        <div className={'steps_button'}>
          <Button type={'button'} color={'blue'} onClick={this.handleCancelClick}>
            {'Нет'}
          </Button>

          <Button type={'button'} color={'orange'} onClick={this.handleOkClick}>
            {'Да'}
          </Button>
        </div>
      </Modal>
    );
  }
}
